import { Convenio } from '@/types/licitacoes/convenio';
import { FiltrosConvenios } from '@/types/licitacoes/convenio/filtros-convenios';
import { InformacaoCancelamento } from '@/types/licitacoes/convenio/informacao-cancelamento';
import { ParticipanteConvenio } from '@/types/licitacoes/participante-convenio';
import { PortalError } from '@/types/portal-error';
import { Service } from '../mainService';

const conveniosService = {
    buscarConvenios,
    listarTiposConvenio,
    listarBancos,
    filtrarConvenios,
    removerConvenio,
    buscarConvenio,
    listarLogs,
    baixarAnexo,
    adicionarConvenio,
    editarConvenio,
    adicionarParticipante,
    removerParticipante,
    importarXml,
    baixarRelatorioDeInconsistencias,
    cancelarConvenio,
    desfazerCancelamento
}

async function buscarConvenios(page, pageSize) {
    try {
        const url = process.env.VUE_APP_LICITACOES_API + "/convenio/listar?page=" + page + "&pageSize=" + pageSize
        const response = await Service.$http.get(url);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function buscarConvenio(id: string) {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_LICITACOES_API + "/convenio/buscar/" + id);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function baixarAnexo(id) {
    try {
        const response = await Service.$http.get(process.env.VUE_APP_LICITACOES_API + "/convenio/baixaranexo/" + id, { responseType: "blob" });
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function listarLogs(id: number) {
    try {
        const url = process.env.VUE_APP_LICITACOES_API + "/convenio/listarLogs/" + id
        const response = await Service.$http.get(url);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function listarTiposConvenio() {
    try {
        const url = process.env.VUE_APP_LICITACOES_API + "/convenio/listarTiposConvenio/"
        const response = await Service.$http.get(url);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function listarBancos() {
    try {
        const url = process.env.VUE_APP_LICITACOES_API + "/convenio/listarBancos/"
        const response = await Service.$http.get(url);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function adicionarConvenio(infoConvenio: Convenio, arquivoEdital: any) {
    try {
        const data = infoConvenio.toFormData();
        data.append('ArquivoTextoConvenio', arquivoEdital)
                
        const response = await Service.$http.post(process.env.VUE_APP_LICITACOES_API + "/convenio/adicionar", data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function adicionarParticipante(infoParticipante: ParticipanteConvenio, idConvenio: string) {
    try {     
        const data = infoParticipante.toFormData();        
        const response = await Service.$http.post(process.env.VUE_APP_LICITACOES_API + "/convenio/adicionarParticipante/"+idConvenio, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function editarConvenio(idConvenio: number, infoConvenio: Convenio, arquivoEdital: any) {
    try {
        const data = infoConvenio.toFormData();
        if(arquivoEdital !== null)
            data.append('ArquivoTextoConvenio', arquivoEdital)
        
        const response = await Service.$http.post(process.env.VUE_APP_LICITACOES_API + "/convenio/editar/"+idConvenio, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function importarXml(arquivo) {
    try {
        const data = new FormData();
        data.append("zipFile", arquivo);
        const response = await Service.$http.post(process.env.VUE_APP_LICITACOES_API + "/convenio/importar/xml", data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function baixarRelatorioDeInconsistencias(data) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_LICITACOES_API + "/convenio/relatoriodeinconsistencias", data, { responseType: "blob" });
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function removerConvenio(id: number) {
    try {
        const response = await Service.$http.delete(process.env.VUE_APP_LICITACOES_API + "/convenio/remover/" + id);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function filtrarConvenios(page: number, pageSize: number, filtros: FiltrosConvenios): Promise<any> {
    const url = `${process.env.VUE_APP_LICITACOES_API}/convenio/filtrarConvenios?page=${page}&pageSize=${pageSize}${filtros.toQueryString()}`
    const response = await Service.$http.get(url);
    if (response && response.status === 200) {
        return response.data
    } else {
        throw new PortalError(response.data?.msg || 'Ocorreu um erro ao realizar a consulta. Verifique se os filtros de pesquisa aplicados podem ser refinados!')
    }
}

async function removerParticipante(idParticipante: string) {
    //console.log('removerparticipante '+idParticipante)
    try {                
        const response = await Service.$http.delete(process.env.VUE_APP_LICITACOES_API + "/convenio/removerParticipante/"+idParticipante);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function cancelarConvenio(infoAnulacao: any) {
    try {
        const data = new FormData();
        data.append('DeMotivoAnulacao', infoAnulacao.motivoCancelamento.toString())
        data.append('DtAnulacao', infoAnulacao.dataCancelamento.toISOString())
        data.append('ArquivoTextoAnulacao', infoAnulacao.arquivoCancelamentoForm)
                
        const response = await Service.$http.post(process.env.VUE_APP_LICITACOES_API + "/convenio/cancelarConvenio/"+infoAnulacao.idConvenio, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        });
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function desfazerCancelamento(idConvenio) {
    try {
        const response = await Service.$http.post(process.env.VUE_APP_LICITACOES_API + "/convenio/desfazerCancelamento/"+idConvenio);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

export default conveniosService;